import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { DataApiService } from 'src/app/Services/data-api.service';
import { AlertRefreshComponent } from '../dialogs/alert-refresh/alert-refresh.component';
export interface DialogData { 
  row:any,
  typeuser:any
}

@Component({
  selector: 'app-ver-perfil',
  templateUrl: './ver-perfil.component.html',
  styleUrls: ['./ver-perfil.component.scss']
})
export class VerPerfilComponent implements OnInit {

  constructor(
    private dataApi:DataApiService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<VerPerfilComponent>,
    @Inject(MAT_DIALOG_DATA) public data2: DialogData
  ) { }
  //private id = this.row.data;
  typeUser = this.data2.typeuser;

  private mensaje="Los datos han sido cambiados con éxito";
  public formPerfilPersona = {
    id: this.data2.row.id,
    telefono1: this.data2.row.telefono1,
    telefono2: this.data2.row.telefono2
  }
  public formPerfilCompany={
    id: this.data2.row.id,
    nombre_comercial:this.data2.row.nombre_comercial,
    razon_social:this.data2.row.razon_social,
    ruc:this.data2.row.ruc,
    direccion:this.data2.row.direccion,
    name:this.data2.row.name,
    surname:this.data2.row.surname,
    telefono1:this.data2.row.telefono1,
    telefono2:this.data2.row.telefono2,
    area:this.data2.row.area
  }
  
  ngOnInit() {
    console.log()
  }

  editarPerfilPersona(){    
    this.dataApi.perfilPersona(this.formPerfilPersona).subscribe(
      data=>this.handleResponse(data),
      error=>this.handleError(error)
    )
  }
  editarPerfilCompany(){
    this.dataApi.perfilCompany(this.formPerfilCompany).subscribe(
      data=>this.handleResponse(data),
      error=>this.handleError(error)
    )
  }

  handleResponse(data){
    this.dialog.closeAll();       
    const dialogRef = this.dialog.open(AlertRefreshComponent,{
      width:"280px",
      data:{mensaje:this.mensaje},
      disableClose: false,
      autoFocus:true
    }); 
  }

  handleError(error){
    console.log(error)
  }
}
